"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTimeUnitToElasticsearchDateMath = mapTimeUnitToElasticsearchDateMath;
function mapTimeUnitToElasticsearchDateMath(unit) {
    switch (unit) {
        case 'HOURS':
            return 'h';
        case 'DAYS':
            return 'd';
        case 'WEEKS':
            return 'w';
        case 'SECONDS':
            return 's';
        case 'MINUTES':
            return 'm';
        case 'MONTHS':
            return 'M';
        case 'YEARS':
            return 'y';
        default:
            throw new Error(`Invalid time unit: ${unit}`);
    }
}
//# sourceMappingURL=utils.js.map